<style>
    .label {
        font-weight: 600;
    }

    .info-box {
        height: 100px; /* Fija la altura */
        overflow: auto; /* Permite el scroll si el contenido excede la altura */
        white-space: pre-line;
        padding: 15px; /* Espacio interno más generoso */
        border: 1px solid #ddd; /* Borde más sutil */
        border-radius: 8px; /* Bordes redondeados */
        font-size: 14px; /* Tamaño de fuente */
        line-height: 1.6; /* Mayor espaciado entre líneas para mejorar la legibilidad */
        background-color: #f4f6f9; /* Color de fondo más suave */
        width: 100%; /* Ajusta el ancho */
        box-sizing: border-box; /* Padding no afecta el tamaño total */
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Sombra suave para darle profundidad */
        color: #333; /* Color del texto */
    }

    .info-box:focus {
        outline: none; /* Quita el borde predeterminado del input al enfocarse */
        border-color: #a0d1fb; /* Color de borde más vibrante al enfocarse */
        box-shadow: 0 0 6px rgba(32, 150, 243, 0.5); /* Sombra más vibrante al enfocarse */
    }

</style>
<template>
    <div class="">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body" style="margin-top: -4%;">
            <form ref="form" data-url="/crud" :class="{ 'loading-opacity': preloader }">
                <div class="form-group card-with-shadow p-2 mt-3">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="customer_po_number" class="label"> {{ $t("customer_po_number") }}</label>
                                <app-input 
                                    type="text" 
                                    v-model="inputs.customer_po_number"
                                    :placeholder="$t('customer_po_number')"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="delivery_location" class="label"> {{ $t("delivery_location") }}</label>
                                <app-input
                                    type="search-select"
                                    v-model="inputs.delivery_location"
                                    :placeholder="'Select delivery location'"
                                    :list="deliveryLocations"
                                    @input="drawDeliveryLocation"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="form-group col-md-3">
                            <div class="form-group">
                                <label for="detailDeliveryLocation" class="label"> {{ $t("detailDeliveryLocation") }} </label>
                                <div class="info-box"> {{ detailDeliveryLocation }}</div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="delivery_date" class="label"> {{ $t("delivery_date") }}</label>
                                <app-input 
                                    type="date" 
                                    v-model="inputs.delivery_date"
                                    :placeholder="$t('delivery_date')"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                         <div class="col-md-3">
                            <div class="form-group">
                                <label for="comments" class="label"> {{ $t("comments") }}</label>
                                 <textarea
                                    :placeholder="$t('commnets')"
                                    class="form-control"
                                    v-model="inputs.comments"
                                    rows="2"
                                    :disabled="isDisabled"
                                >
                                </textarea>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="mt-5 col-md-3 action-buttons">
                        <button type="button" class="btn btn-primary mr-2  w-100" 
                            @click="saveDate"
                            :disabled="isDisabled"
                        >
                            {{ $t('save') }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import { SubContractStoreMixin } from '../Mixins/SubContractStoreMixin.js';

export default {
    name: "add_contractDetail_form",
    mixins: [FormMixin, SubContractStoreMixin],
    data() {
        return {
            isDisabled : true,
            deliveryLocations : [],
            contractCustomer : null,
            detailDeliveryLocation : null,
            inputs: {
                customer_po_number : null,
                delivery_location : null,
                delivery_date : null,
                comments : null,
            },
            preloader : false,
            contractId : null,
        }  
    },
    methods: {
        validateForm(inputs, validations) {
            for (const [field, message] of Object.entries(validations)) {  
                const value = field.split('.').reduce((o ,i) => o[i], inputs);
                if (!value) {     
                    this.$toastr.e(this.$t(message));
                    return false;
                }
                if (typeof value === 'object') {
                    if (!Object.values(value)[0]) {
                        this.$toastr.e(this.$t(message));
                        return false;
                    }   
                }
            }
            return true;
        },

        async saveDate(){
            this.preloader = true;
            try {
                const { data } = await axios.post(
                    `/api/subcontract/save_po/${this.contractId}`,
                    this.inputs
                );
                this.$toastr.s(data.message || this.$t('saved_successfully'));
                // this.$hub.$emit('change-tab-subtab', 'tab-2');
            } catch (e) {
                const errors = e.response?.data?.errors;
                const msg = errors
                    ? Object.values(errors)[0][0]
                    : (e.response?.data?.message || this.$t('something_went_wrong'));
                this.$toastr.e(msg);
            } finally {
                this.preloader = false;
            }
        },

        handleDeliveryLocations(contract_customer){
            const contract = contract_customer[0];
            this.contractCustomer = contract;
            for (let index = 1; index <= 4; index++) {
                const key = `ship_address${index}`;
                if (contract[key]) {
                    this.deliveryLocations.push({id:contract[key].id, value:contract[key].name, option:index});
                }
            }
        },

        drawDeliveryLocation(option){
            let keyAddress = 0;
            let keyCity = 0;
            const contract = this.contractCustomer;
            const {customer_company: company} = contract;

            for (let index = 1; index <= 4; index++) {
                const key = `Ship_address_id_${index}`;
                if (contract[key] == option) {
                    keyAddress = `ship_address${index}`;
                    keyCity = `ship_city${index}`;
                    break;
                }
            }

            const dataAddress = contract[keyAddress];
            const dataCity = contract[keyCity];
            const response = [];

            response.push(company.Second_Title);
            if(dataAddress.address) response.push(dataAddress.address);
            
            let textCity = '';
            if (dataCity?.name) textCity = dataCity.name;
            if (dataAddress?.postal_zip_code) textCity += `${textCity != '' ? ',' : ''} ${dataAddress.postal_zip_code}`;
            if (textCity) response.push(textCity);
            
            if (dataAddress.phone) response.push(dataAddress.phone);

            this.detailDeliveryLocation = response.join('\n');        
        },

        async loadPo() {
            try {
                this.preloader = true;
                const { data } = await axios.get(`/api/subcontract/get_po/${this.contractId}`);
                if (data) {
                    const {subcontract} = data;
                    const {contract} = subcontract;
                    const {contract_customer} = contract;

                    if (contract_customer) {
                        this.handleDeliveryLocations(contract_customer);
                    }
                    
                    this.inputs = {
                        customer_po_number: data.customer_po_number,
                        delivery_location: data.delivery_location,
                        delivery_date: data.delivery_date,
                        comments: data.comments,
                    };

                    if (this.inputs['delivery_location']) {
                        this.drawDeliveryLocation(this.inputs['delivery_location']);
                    }
                }
                this.preloader = false;
            } catch (e) {
                console.log(`error e`);
                this.preloader = false;
            }
        },
    },

    watch: {
        inputs: {
            deep: true,
            handler(newVal) {
                this.saveTab('products', newVal);
            },
        },
    },

    props: {
        props: { type: Object, default: () => ({}) }
    },
    mounted() {
        this.contractId = this.props.id;
        this.loadPo();
            
        let isLogisticCoordinator = false;
        const roles = user.roles;
        roles.forEach( rol => {
            if (rol.name === 'Logistics Coordinator') {
                isLogisticCoordinator = true;
            }
        });
        if (isLogisticCoordinator) {
            this.isDisabled = false;
        }
    }
}
</script>
